module.exports = __webpack_public_path__ + "img/Pirkey-Barber-Case-Study-600px-New.bc971042.jpeg";